import type { SearchFilterType } from '@/scopes/search/search/infrastructure/api/types'
import { SearchState } from '@/scopes/search/search/infrastructure/store/store'

export function getFilterAISelection(state: SearchState, filterType: SearchFilterType) {
  return state.aiFilterSelection[filterType]
}

export function isFlightOnlySelector(state: SearchState) {
  return Boolean(state.filterSelection?.IsFlightOnly)
}
